var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar'),_c('SideNav'),_c('Cart'),_c('v-main',[_c('transition',{attrs:{"name":"router-anim"}},[_c('router-view')],1)],1),_c('Snackbar'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }